module.exports = __webpack_public_path__ + "static/img/payway2.dbfaef0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/payway2.png
// module id = 0POO
// module chunks = 0